<template>
    <div v-loading="saveLoading" class="inner-container" :element-loading-text="saveText">
        <el-scrollbar class="dataroom-dataset-el-scrollbar">
            <div>
                <page-header :title="!isEdit ? '原始数据集详情' : dataForm.id ? '编辑原始数据集' : '新增原始数据集'" :save-btn="isEdit"
                    url="https://www.yuque.com/chuinixiongkou/bigscreen/ry3ggnrts7q3ro1g" @back="goBack"
                    @save="save('form')" />
            </div>
            <el-row>
                <el-col :span="6">
                    <span class="dataroom-dataset-basic-info">
                        基本信息
                    </span>
                    <el-form ref="form" :model="dataForm" :rules="rules" label-width="120px" style="padding: 16px 16px 0;"
                        class="bs-el-form">
                        <el-form-item label="数据集名称" prop="dataSetName">
                            <el-input v-model="dataForm.dataSetName" class="bs-el-input" clearable :disabled="!isEdit" />
                        </el-form-item>
                        <el-form-item label="分组" prop="parentCode">
                            <type-select :type-id="dataForm.parentCode" @update="dataForm.parentCode = $event" />
                        </el-form-item>
                        <el-form-item label="数据源" prop="dataSourceCode">
                            <el-select v-model="dataForm.dataSourceCode" class="bs-el-select" popper-class="bs-el-select"
                                clearable filterable :disabled="!isEdit" @change="setSource">
                                <el-option v-for="source in sourceList" :key="source.id" :label="source.name"
                                    :value="source.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="数据库" prop="databaseName">
                            <el-select v-model="dataForm.databaseName" class="bs-el-select" popper-class="bs-el-select"
                                clearable filterable disabled >
                                <el-option :label="baseList" :value="baseList" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关联原始表" prop="tableName">
                            <el-select v-model="dataForm.tableName" v-loading="selectorLoading"
                                element-loading-spinner="el-icon-loading" class="bs-el-select" clearable filterable
                                :disabled="!isEdit" @change="setTable">
                                <el-option-group label="表">
                                    <el-option v-for="table in tableList" :key="table" :label="table" :value="table" />
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="输出字段" prop="fieldInfo">
                            <el-select v-model="dataForm.fieldInfo" class="bs-el-select" popper-class="bs-el-select"
                                placeholder="请选择字段（为空时默认选择全部字段）" clearable filterable multiple :disabled="!isEdit"
                                @change="setFields">
                                <el-option v-if="fieldList.length" label="全选" value="全选">
                                </el-option>
                                <el-option v-for="field in fieldList" :key="field" :label="field" :value="field">
                                    {{ field }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否去重" prop="dr">
                            <el-radio-group v-model="dataForm.dr" class="bs-el-radio-group" :disabled="!isEdit"
                                @change="repeatStatusChange">
                                <el-radio :label="1">
                                    是
                                </el-radio>
                                <el-radio :label="0">
                                    否
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="缓存" prop="cache">
                            <el-radio-group v-model="dataForm.cache" class="bs-el-radio-group">
                                <el-radio :label="1">
                                    开启
                                </el-radio>
                                <el-radio :label="0">
                                    关闭
                                </el-radio>
                            </el-radio-group>
                            <el-tooltip class="item" effect="light"
                                content="开启缓存:会在首次调用该数据集时，将结果缓存，在接下来的十分钟内，若再次被调用则直接返回缓存中的数据，注意：在当前数据集编辑页面缓存不生效"
                                placement="top" popper-class="dataroom-el-tooltip">
                                <i class="el-icon-warning-outline"
                                    style="color: #E3C98C;margin-left: 16px;font-size:14px" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="备注" prop="description">
                            <el-input v-model="dataForm.description" class="bs-el-input" :disabled="!isEdit" />
                        </el-form-item>
                        <!-- <el-form-item label="标签" prop="labelIds">
                                        <label-select :dataset-id="datasetId" :id-list="dataForm.labelIds"
                                            @commit="(ids) => { dataForm.labelIds = ids }" />
                                    </el-form-item> -->
                    </el-form>
                </el-col>
                <el-col :span="18">
                    <div v-if="isEdit" style="margin-top: 12px;">
                        <data-preview ref="dataPreview" :data="dataPreviewList" :loading="dataPreviewTableLoading"
                            :total-count="totalCount" :size="size" :current="current"
                            @size-change="(value) => sizeChangeHandle(value)"
                            @current-change="(value) => currentChangeHandle(value)" />
                    </div>
                </el-col>
            </el-row>
        </el-scrollbar>
    </div>
</template>

<script>
import PageHeader from '@/components/data-room-ui/packages/dataSet/components/PageHeader.vue'
import DataPreview from '@/components/data-room-ui/packages/dataSet/components/DataPreview.vue'
import TypeSelect from '@/components/data-room-ui/packages/dataSet/components/TypeSelect.vue'
import {
    datasetExecuteTest,
    getDataset, datasetUpdate, datasetAdd
} from '../assets/js/datasetConfigService'
import { datasourceList, getSourceTable, getbaseTable, getTableFieldList } from '../assets/js/dataSourceService.js'
import cloneDeep from 'lodash/cloneDeep'
import { datasetMixin } from '@/components/data-room-ui/packages/assets/js/mixins/dataset.js'
export default {
    dataSetName: 'OriginalEditForm',
    components: {
        PageHeader,
        DataPreview,
        TypeSelect
    },
    mixins: [datasetMixin],
    data() {
        return {
            dataPreviewTableLoading: false,
            dataForm: {
                id: '',
                dataSetName: '',
                parentCode: '',
                datasetType: 'original',
                description: '',
                cache: 0,
                labelIds: [],
                // 以下为config信息
                dataSourceCode: '',
                dr: 1,
                tableName: '',
                databaseName: '',
                fieldInfo: [],
                fieldDesc: {},
                fieldList: []
            },
            rules: {
                dataSetName: [
                    { required: true, message: '数据集名称不能为空', trigger: 'blur' },
                ],
                dataSourceCode: [
                    { required: true, message: '请选择数据源', trigger: 'blur' }
                ],
                tableName: [
                    { required: true, message: '请选择原始表', trigger: 'change' }
                ],
                databaseName: [
                    { required: true, message: '请选择数据库', trigger: 'change' }
                ],
                dr: [
                    { required: true, message: '请选择是否去重', trigger: 'blur' }
                ],
                parentCode: [
                    { required: true, message: '请选择分组', trigger: 'blur' }
                ]
            },
            // 数据源列表
            sourceList: [],
            // 表列表
            tableList: [],
            // 数据库列表
            baseList: [],
            // 字段列表
            fieldList: [],
            selectorLoading: false,
        }
    },
    computed: {
        noDataTableDisplayFields() {
            // 表格列对象
            const tableColumnObject = {}
            this.structurePreviewList.forEach(item => {
                tableColumnObject[item.fieldName] = ''
            })
            return tableColumnObject
        },

        sortedStructurePreviewList() {
            const list = this.structurePreviewList
            list.sort((a, b) => {
                return a.orderNum - b.orderNum
            })
            return list
        }
    },
    watch: {
        sortedStructurePreviewList(val) {
            this.structurePreviewListCopy = cloneDeep(val)
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        /**
         * 初始化
         * 1.获取分类树
         * 2.获取数据源列表
         * 3.获取数据集详情
         * 4.获取原始表列表
         * 5.获取字段列表
         */
        async init() {
            this.queryAllSource()
            if (!this.datasetId) {
                return
            }
            // 获取详情
            getDataset({ data: { id: this.datasetId } }).then(res => {
                this.dataForm.id = res.id
                this.dataForm.dataSetName = res.dataSetName
                this.dataForm.parentCode = res.parentCode
                this.dataForm.description = res.description
                this.dataForm.cache = Number(res.cache)
                this.dataForm.dr = Number(res.dr)
                this.dataForm.datasetType = res.type
                // this.dataForm.databaseName = res.type
                this.dataForm.tableName = res.table
                this.dataForm.fieldInfo = res.outputField.split(",")
                this.dataForm.dataSourceCode = res.dataSourceCode
                this.queryAllTable2(res.table)
                this.queryAllField()
            })
        },

        /**
         * 保存数据集
         * @param formName 表单名称
         * @param noCheckToSave 是否不检查直接保存
         */
        save(formName, noCheckToSave = false) {
            // if (!this.structurePreviewList.length) {
            //   this.$message.warning('该原始数据集未生成输出字段，请重新检查')
            //   return
            // }
            // if (!noCheckToSave) {
            //   const temp = this.structurePreviewList.some(item => {
            //     return item.fieldDesc === ''
            //   }) // true-存在为空
            //   if (temp) {
            //     this.fieldDescVisible = true
            //     return
            //   }
            // }
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.saveLoading = false
                    this.saveText = ''
                    return false
                }
                var outputField
                if (this.dataForm.fieldInfo.length == 0) {
                    outputField = ''
                } else {
                    outputField = this.dataForm.fieldInfo.join();
                }
                const datasetParams = {
                    id: this.dataForm.id,
                    dataSetName: this.dataForm.dataSetName,
                    parentCode: this.dataForm.parentCode,
                    description: this.dataForm.description,
                    dataSourceCode: this.dataForm.dataSourceCode,
                    cache: String(this.dataForm.cache),
                    dr: String(this.dataForm.dr),
                    databaseName: this.dataForm.databaseName,
                    "table": this.dataForm.tableName,
                    "outputField": outputField,
                    "type": "1",
                    "enterprise": localStorage.getItem('enterprise_id'),
                }

                this.saveLoading = true
                this.saveText = '正在保存...'
                const saveOriginal = this.dataForm.id ? datasetUpdate : datasetAdd
                saveOriginal({ data: { ...datasetParams } }).then(() => {
                    this.goBack()
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                    this.$parent.init(false)
                    this.$parent.setType = null
                    this.saveLoading = false
                    this.saveText = ''
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '保存失败'
                    })
                    this.saveLoading = false
                    this.saveText = ''
                })
            })
        },
        /**
         * 获取数据源列表
         */
        queryAllSource() {
            datasourceList({
                data: {
                    enterprise_id: localStorage.getItem('enterprise_id'),
                }
            }).then((data) => {
                this.sourceList = data.data || []
            })
        },
        /**
         * 选中数据源
         * @param value
         */
        setSource(value) {
            if (value != '') {
                var hh = this.sourceList.find((item, index) => { return item.id == value })
                this.baseList = hh.databaseName
                this.dataForm.databaseName = hh.databaseName
                // this.queryAllTable()
                 this.queryAllTable2(hh.databaseName)
            }
        },
        /**
       * 选中数据源
       * @param value
       */
        setSource2(value) {
            if (value != '') {
               
            }
        },
        /**
         * 获取原始表列表
         * 1.获取表列表
         * 2.获取视图列表
         */
        // queryAllTable() {
        //     getSourceTable({ data: { id: this.dataForm.dataSourceCode } }).then(res => {
        //         this.baseList = res
        //     }).catch(() => {
        //         this.baseList = []
        //     })
        // },
        queryAllTable2(databaseName) {
            getbaseTable({ data: { id: this.dataForm.dataSourceCode, databaseName: databaseName } }).then(res => {
                this.tableList = res.table
            }).catch(() => {
                this.tableList = []
            })
        },
        /**
         * 选中原始表
         * @param value
         */
        async setTable() {
            if (!this.dataForm.tableName) {
                this.dataForm.fieldInfo = []
                return
            }
            await this.queryAllField()
        },
        repeatStatusChange() {
            this.getPreViewData()
        },
        /**
         * 获取原始表字段列表
         */
        queryAllField() {
            this.dataPreviewTableLoading = true
            return new Promise((resolve, reject) => {
                getTableFieldList({ data: { id: this.dataForm.dataSourceCode, databaseName: this.dataForm.databaseName, tableName: this.dataForm.tableName } })
                    .then((data) => {
                        this.fieldList = data.field
                        this.dataPreviewTableLoading = false
                        this.dataPreviewList = data
                        resolve()
                    })
                    .catch(() => {
                        this.fieldList = []
                        reject()
                    })
            })
        },
        /**
         * 选中字段
         * @param values 选中的字段列表
         */
        setFields(values) {
            if (values.includes('全选')) {
                if (values.length > this.fieldList.length) {
                    this.dataForm.fieldInfo = []
                } else {
                    this.dataForm.fieldInfo = this.fieldList.map(field => field.columnName)
                }
            }
        },

        // 每页大小改变触发
        sizeChangeHandle(value) {
            this.size = value
            this.current = 1
            this.getData()
        },
        // 当前页数改变
        currentChangeHandle(value) {
            this.current = value
            this.getData()
        },
        setField() {
            this.structurePreviewList = cloneDeep(this.structurePreviewListCopy)
            this.fieldsetVisible = false
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/index.scss";
@import "@/components/data-room-ui/packages/assets/style/tooltip.scss";

::v-deep .el-input__inner {
    width: 100% !important;
}

::v-deep .fieldDescCheck {
    .el-dialog__body {
        height: fit-content !important;
        min-height: unset !important;
    }
}

.title-style {
    padding: 8px 12px;
    background-color: #f6f7fb;
    border-left: 5px solid #606266;
    margin: 16px 16px 0 0;
}

.field-wrap {
    max-height: 156px;
    overflow: auto;
    margin-right: 16px;

    .field-item {
        line-height: 32px;
        padding: 0 12px 0 16px;
        cursor: pointer;

        .edit_field {
            display: none;
        }

        &:hover {
            background-color: #f2f7fe;

            .edit_field {
                display: block;
            }
        }
    }
}

::v-deep .dataroom-table-box.is-Edit .el-table {
    .el-table__body-wrapper {
        max-height: unset !important;
    }
}

.result-view {
    font-size: 14px;
    font-weight: 600;
    color: var(--bs-el-text);
    position: relative;
    padding: 16px 0;
    padding-left: 12px;
    border-bottom: 1px solid#151a26;

    &::before {
        content: "";
        height: 14px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-left: 4px solid#409EFF;
    }
}

.dataroom-table-box {
    height: 100% !important;
    margin-bottom: 0 !important;
}

.bs-pagination {
    padding: 16px !important;
    position: unset !important;

    ::v-deep .el-input__inner {
        width: 110px !important;
        border: none;
        // background: #151A26;
    }
}

// 修改el-select样式 loading 位置
::v-deep .el-loading-spinner {
    top: 75%;
}

.bs-el-select {
    width: 100% !important;
}

::v-deep .el-input__inner {
    width: 100% !important;
}
</style>
<style lang="scss">
@import "@/components/data-room-ui/packages/assets/style/tooltip.scss";
</style>
